import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Row,
  Table,
  Button,
  Space,
  Popconfirm,
  Breadcrumb,
  Typography,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import Moment from "react-moment";
import {
  deleteCustomerRecord,
  getAllCustomerRecords,
} from "../viewCustomer/viewCustomerSlice";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {
  isSuperAdmin,
  isAdmin,
} from "../../../Login../../../src/features/Authentication/Login/LoginSlice";

export function ViewCustomers() {
  const dispatch = useDispatch();
  const { Title } = Typography;
  const customerRecords = useSelector((state) => state.viewCustomer);
  const [records, modifyRecords] = useState(customerRecords?.customerRecords);
  const [page, setPage] = useState(1);
  const { Column } = Table;
  const history = useHistory();
  useEffect(() => {
    dispatch(getAllCustomerRecords());
  }, [dispatch]);

  useEffect(() => {
    modifyRecords(customerRecords?.customerRecords);
  }, [customerRecords]);
  const editCustomer = (e) => {
    history.push("addcustomer/" + e);
  };
  const deleteCustomer = (e) => {
    dispatch(deleteCustomerRecord(e.customerID));
  };
  return (
    <>
      <Row className="titlt-part" align="middle">
        <Col xs={24} md={8}>
          <Title level={4}> View Customer</Title>
        </Col>
        <Col xs={24} md={16} className="text-right">
          <Space>
            <Breadcrumb>
              <Breadcrumb.Item href="/DashBoard">
                <HomeOutlined />
                <span>Home</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/customer/viewcustomer">Customers</Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>Add Customer</Breadcrumb.Item>
            </Breadcrumb>
            <Link to="/customer/addcustomer">
              <Button type="primary" icon={<PlusOutlined />}>
                Add Customer
              </Button>
            </Link>
          </Space>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div class="mt-10px">
            <Table
              size="middle"
              pagination={{
                onChange(current) {
                  setPage(current);
                },
              }}
              bordered
              //please check if rowkey is required
              rowkey={(record) => record.id}
              dataSource={records}
              scroll={{ x: 1000 }}
            >
              <Column
                title="S.No"
                dataIndex="customerID"
                key="customerID"
                // render={(value, item, index) => index + 1}
                render={(value, item, index) => (page - 1) * 10 + (index + 1)}
              />
              <Column
                title="Customer Name"
                dataIndex="customerName"
                key="customerName"
                sorter={(a, b) =>
                  a.contactNumber.length - b.contactNumber.length
                }
              />
              <Column
                title="Contact Number"
                dataIndex="contactNumber"
                key="contactNumber"
                sorter={(a, b) => a.contactNumber - b.contactNumber}
              />
              <Column title="Email" dataIndex="email" key="email" />
              <Column title="State" dataIndex="state" key="state" />
              <Column
                title="Created By"
                dataIndex="createdByUser"
                key="createdByUser"
              />
              <Column
                title="Created Date"
                dataIndex="createdDateTime"
                key="createdDateTime"
                align="center"
                width={100}
                render={(createdDateTime) => (
                  <>
                    <p className="mt-0">
                      {createdDateTime === null ? (
                        ""
                      ) : (
                        <>
                          <Moment utc local format="DD-MMM-YYYY">
                            {createdDateTime}
                          </Moment>
                        </>
                      )}
                    </p>
                  </>
                )}
              />
              <Column
                title="Updated By"
                dataIndex="updatedByUser"
                key="pdatedByUser"
              />
              <Column
                title="Updated Date"
                width={100}
                dataIndex="updatedDateTime"
                key="updatedDateTime"
                align="center"
                render={(updatedDateTime) => (
                  <>
                    <p className="mt-0">
                      {updatedDateTime === null ? (
                        ""
                      ) : (
                        <>
                          <Moment utc local format="DD-MMM-YYYY">
                            {updatedDateTime}
                          </Moment>
                        </>
                      )}
                    </p>
                  </>
                )}
              />
              <Column
                title="Action"
                key="action"
                render={(text, record) => (
                  <Space size="small">
                    <Button
                      icon={<EditOutlined />}
                      size="small"
                      onClick={() => editCustomer(record.customerID)}
                    ></Button>
                    {/* {record.projectFullRecord.length <= 0 ? ( */}
                    <Popconfirm
                      title="Sure to delete?"
                      onConfirm={() => deleteCustomer(record)}
                    >
                      {(isSuperAdmin() || isAdmin()) && (
                        <Button
                          danger
                          icon={<DeleteOutlined />}
                          size="small"
                        ></Button>
                      )}
                    </Popconfirm>
                    {/* ) : (
                       <Button 
                    //     danger
                    //     icon={<DeleteOutlined />}
                    //     size="small"
                    //     title="Delete is not allowed, as we have projects associated to customer"
                    //     disabled={true}
                    //   ></Button>
                    // )}*/}
                  </Space>
                )}
              />
            </Table>
          </div>
        </Col>
      </Row>
    </>
  );
}
